import { BASE_API } from "../utils/constants";

export async function getFinanceDashboardApi(token, params = {}) {
  try {
    const query = new URLSearchParams(params).toString();
    const url = `${BASE_API}/api/finance/dashboard/?${query}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Dashboard request failed (${response.status}): ${text}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}
